(function () {
  const duration = 59 * 60 * 1000;
  const storageKey = 'namorra-cart-countdown-start-v1';
  let sessionStart;

  function countdown(now, start) {
    const elapsed = ((now - start) % duration + duration) % duration;
    const seconds = Math.ceil((duration - elapsed) / 1000);
    return String(Math.floor(seconds / 60)).padStart(2, '0') + ':' +
      String(seconds % 60).padStart(2, '0');
  }

  // Export only the pure timer calculation for boundary verification in Node.
  if (typeof module !== 'undefined' && module.exports) module.exports = countdown;
  if (typeof window === 'undefined' || customElements.get('namorra-cart-delivery')) return;

  function getSessionStart(now) {
    if (sessionStart !== undefined) return sessionStart;
    let saved;
    try { saved = Number(sessionStorage.getItem(storageKey)); } catch (error) { /* Storage may be disabled. */ }
    sessionStart = Number.isFinite(saved) && saved > 0 && saved <= now ? saved : now;
    try { sessionStorage.setItem(storageKey, String(sessionStart)); } catch (error) { /* Keep the in-memory timer. */ }
    return sessionStart;
  }

  class NamorraCartDelivery extends HTMLElement {
    connectedCallback() {
      if (this.interval) return;
      this.counter = this.querySelector('[data-cart-countdown]');
      this.arrival = this.querySelector('[data-cart-delivery-date]');
      this.headline = this.querySelector('.nc-cart-delivery__headline');
      this.zone = this.dataset.timeZone || 'Europe/London';
      this.start = getSessionStart(Date.now());
      this.update = this.update.bind(this);
      this.update();
      this.interval = setInterval(this.update, 1000);
      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => this.fitHeadline());
        this.resizeObserver.observe(this);
      }
    }

    update() {
      if (!this.isConnected || !this.counter || !this.arrival) return;
      if (typeof window.NamorraDeliveryState !== 'function') return;
      const now = new Date();
      const timing = window.NamorraDeliveryState(now, this.zone);
      const label = countdown(now.getTime(), this.start);
      if (this.counter.textContent !== label) this.counter.textContent = label;
      if (this.arrival.textContent !== timing.delivered) this.arrival.textContent = timing.delivered;
      if (this.hidden) { this.hidden = false; this.fitHeadline(); }
    }

    fitHeadline() {
      if (!this.headline || this.clientWidth === 0) return;
      this.headline.style.removeProperty('font-size');
      const size = parseFloat(getComputedStyle(this.headline).fontSize);
      if (this.headline.scrollWidth > this.headline.clientWidth) {
        this.headline.style.fontSize = Math.max(10, Math.floor(size * this.headline.clientWidth / this.headline.scrollWidth * 10) / 10) + 'px';
      }
    }

    disconnectedCallback() {
      clearInterval(this.interval);
      this.interval = null;
      if (this.resizeObserver) this.resizeObserver.disconnect();
    }
  }

  customElements.define('namorra-cart-delivery', NamorraCartDelivery);
})();
